export const filterConfig = [
  {
    id: 'frota',
    type: 'text',
    label: 'Busca por Frota',
    placeholder: 'Digite a frota',
  },
  {
    id: 'placa',
    type: 'text',
    label: 'Busca por Placa',
    placeholder: 'Digite a placa',
  },
  {
    id: 'renavam',
    type: 'text',
    label: 'Busca por Renavam',
    placeholder: 'Digite o Renavam',
  },
  {
    id: 'uf',
    type: 'text',
    label: 'Busca por UF',
    placeholder: 'Digite a UF',
    maxLength: 2,
  },
];
